import styled from 'styled-components'
import Spin from 'antd/lib/spin'
import Skeleton from 'antd/lib/skeleton'
import { WHITE, GRAY_HEADER } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  loading?: boolean
  fullSize?: boolean
  width?: number
  color?: string
  buttonWidth?: string
  hasFontSize?: boolean
  backgroundColor?: string
  backgroundImage?: string
  verticalAlign?: string
  cssStyle?: string
  fontSize?: string
}

export const Container = styled.div`
  transition: all 0.5s ease;
  z-index: 2;
  min-height: ${({ loading }: DivProps) => (loading ? '882px' : '120vh')};
  max-width: 1680px;
  margin: 0 auto;
  box-shadow: 0px 5px 14px 8px #c7c7c7;
  font-family: Avenir;
  opacity: ${({ loading }: DivProps) => (loading ? '0' : '1')};
  background: white;
`

export const SearchBarContent = styled.div`
  color: ${WHITE};
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 999;
  transition: all .25s;
  box-shadow: 0px 5px 8px -4px #292929;
  display: flex;
  justify-content: space-between;
  background: #f9f9f9;
  @media (min-width: 992px) {
    display: none;
  }
`

export const Spinner = styled(Spin)`
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
`

export const ImageSkeleton = styled.div`
  width: ${({ fullSize }: DivProps) => (fullSize ? '100%' : '48%')};
  border-radius: 7px;
  height: 262px;
  margin-top: 24px;
  margin-bottom: 18px;
  background: #f1f1f1;
  @media (max-width: 768px) {
    margin-top: ${({ fullSize }: DivProps) => (fullSize ? '0' : '24px')};
  }
`

export const ImageRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`

export const SkeletonDiv = styled(Skeleton)`
  margin-left: -77px;
  li {
    background: #f1f1f1 !important;
  }
`

export const LoadingContainer = styled.div`
  justify-content: center;
  flex-flow: column;
  width: 100%;
  transition: all .25s ease;
  padding: 0 26px;
  position: absolute;
  top: 103px;
  z-index: 1;
  display: ${({ loading }: DivProps) => (loading ? 'flex' : 'none')}
  opacity: ${({ loading }: DivProps) => (loading ? '1' : '0')}
  align-items: center;
`

export const layoutStyle = {
  background: GRAY_HEADER
}

export const BannerImage = styled.img`
  width: 100%;
  object-fit: cover;
  max-height: 512px;
  @media (max-width: 698px) {
    height: 212px;
    max-height: unset;
    object-position: left;
  }
`

export const Fade = styled.div`
  background: linear-gradient(180deg,rgba(0,0,0,0) 0%,rgba(0,0,0,.3) 66.62%);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

export const TitleDiv = styled.div`
  position: absolute;
  bottom: 28px;
  display: flex;
  flex-flow: column;
  align-items: center;
  width: 100%;
  color: white;
  z-index: 1;
  @media (max-width: 767px) {
    align-items: start;
    padding: 0 14px 24px 14px;
    row-gap: 12px;
  }
  @media (max-width: 698px) {
    bottom: 14px;
  }
`

export const Title = styled.div`
  font-size: 54px;
  font-family: Avenir;
  font-weight: bold;
  z-index: 2;
  padding-bottom: 10px;
  line-height: 46px;
  @media (max-width: 698px) {
    font-size: 32px;
    width: 100%;
    text-align: center;
  }
`

export const Stamps = styled.div`
  @media (max-width: 698px) {
    display: none;
  }
`

export const StampsMobile = styled.div`
  display: none;
  position: absolute;
  bottom: -21px;
  right: 14px;
  font-size: 12px;
  @media (max-width: 698px) {
    display: flex;
  }
`

export const CreatedStamp = styled.div`
  display: inline;
  text-transform: capitalize;
`

export const StyledIcon = styled(Icon)`
  margin-right: 6px;
  color: #cdf7ffc7;
  @media (max-width: 698px) {
    color: #9ebfc5;
    margin-right: 4px;
  }
`

export const BadgeDiv = styled.div`
  position: absolute;
  left: 5%;
  bottom: -40px;
  @media (max-width: 767px) {
    bottom: -26px;
  }
`

export const Badge = styled.img`
  width: 68px;
  height: 68px;
  object-fit: cover;
  border-radius: 50%;
  box-shadow: 0px 0px 0px 3px white;
  @media (max-width: 767px) {
    width: 54px;
    height: 54px;
  }
  @media (max-width: 698px) {
    width: 46px;
    height: 46px;
  }
`

export const BadgeTitle = styled.div`
  position: absolute;
  left: 100%;
  top: 34px;
  white-space: nowrap;
  padding-left: 8px;
  font-size: 12px;
  color: #616161;
  font-family: 'Avenir Next W01';
  font-weight: normal;
  @media (max-width: 698px) {
    top: 24px;
  }
`

export const SocialLinks = styled.div`
  position: absolute;
  bottom: 10px;
  right: 3%;
  display: flex;
  flex-wrap: wrap;
`

export const SocialBtn = styled.img`
  max-width: 20px;
  margin-right: 16px;
  opacity: 0.9;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 1;
    transform: scale(1.05);
  }
`

export const LinkBtn = styled(Icon)`
  color: #393939;
  background: white;
  padding: 3px;
  border-radius: 3px;
  font-size: 14px;
  opacity: 0.9;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 1;
    transform: scale(1.05);
  }
`

export const ActionButtons = styled.div`
  position: absolute;
  bottom: -28px;
  right: 3%;
  display: flex;
  flex-wrap: wrap;
`

export const LikeIcon = styled(Icon)`
  margin-right: 4px;
  font-size: 16px;
  color: cornflowerblue;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.6;
    color: 
  }
  @media (max-width: 698px) {
    font-size: 14px;
    margin-left: 4px;
  }
`

export const BodyBlog = styled.div`
  display: flex;
  flex-flow: wrap;
`

export const Description = styled.div`
  margin: 26px auto;
  max-width: 814px;
  padding: 8px 20px;
  font-style: italic;
  text-align: center;
  @media (max-width: 767px) {
    margin: unset;
    margin-top: 32px;
  }
`

export const ImageBlock = styled.img<{ width: number, verticalAlign: string, cssStyle: string}>`
  width: ${props => props.width ? props.width : 100}%;
  align-self: flex-start;
  ${props => props.verticalAlign ? `
    display: flex;
    align-items: ${props.verticalAlign};
  ` : ''}
  @media (max-width: 1024px) {
    object-fit: cover;
  }
  @media (max-width: 767px) {
    width: ${props => props.width && props.width > 50 ? props.width : 100}%;
  }
  ${props => props.cssStyle ? 
    props.cssStyle
  : ''}
`

export const ContainerBlock = styled.div<{ width: number, verticalAlign?: string, cssStyle?: string}>`
  width: ${props => props.width ? `${props.width}%` : '100%'};
  align-self: flex-start;
  ${props => props.verticalAlign ? `
    display: flex;
    align-items: ${props.verticalAlign};
  ` : ''}
  &.textBox {
    padding: 0 22px;
  }
  @media (max-width: 767px) {
    width: ${props => props.width && props.width > 50 ? props.width : 100}%;
  }
  ${props => props.cssStyle ? 
    props.cssStyle
  : ''}
  .slick-dots{
    bottom: 8px;
  }
  .slick-dots li button {
    height: 0;
  }
  .slick-dots li button:before {
    background: white;
    border-radius: 100px;
    border: 1px solid black;
    box-shadow: 0 0 1px 4px 2px white;
    content: '';
    height: 12px;
    width: 12px;
    margin-top: 4px;
    opacity: 0.8 !important;
  }
  .slick-dots li.slick-active button:before {
    background: black;
    border: 1px solid white;
  }
`

export const ContainerBlockRich = styled.div`
  width: ${({ width }: DivProps) => width ? `${width}%` : '100%'};
  text-align: center;
  height: auto;
  padding: 14px 28px;
  color: black;
  background: ${({ backgroundColor }: DivProps) => backgroundColor || 'unset'};
  ${({ verticalAlign }: DivProps) => verticalAlign ? `
    display: flex;
    align-items: ${verticalAlign};
  ` : ''}
  ${({ backgroundImage }: DivProps) => backgroundImage ? `
    background-image: url(${backgroundImage});
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    @media (max-width: 767px) {
      background-size: cover;
    }
    @media (max-width: 698px) {
      max-width: 100%;
    }
  ` : ''}
  ${({ hasFontSize, cssStyle }: DivProps) => cssStyle ? `
    display: flex;
    align-items: center;
    ${cssStyle}
    ${hasFontSize ? `
      span[data-text="true"] {
        ${cssStyle}
      }
    ` : ''}
  ` : ''}
  .rdw-editor-wrapper {
    width: 100%;
  }
  figure:focus-visible {
    outline: none !important;
  }
  @media (max-width: 767px) {
    width: ${({ width }: DivProps) => width && width > 50 ? width : 100}%;
  }
`

export const IframeComponent = styled.iframe<{ width: number, verticalAlign?: string, cssStyle?: string}>`
  width: ${props => props.width ? `${props.width}%` : '100%'};
  height: 328px;
  ${props => props.verticalAlign ? `
    display: flex;
    align-items: ${props.verticalAlign};
  ` : ''}
  @media (max-width: 767px) {
    width: ${props => props.width && props.width > 50 ? props.width : 100}%;
  }
  ${props => props.cssStyle ? 
    props.cssStyle
  : ''}
`

export const VideoPreview = styled.video`
  object-fit: cover;
  margin-bottom: -3px;
  width: 100%;
  height: 100%;
`

export const StyledLink = styled.a`
  transition: all .25s;
  border-radius: 25px;
  padding: 8px 20px;
  box-shadow: 0px 2px 4px -1px #8e8e8e;
  color: ${({ color }: DivProps) => color || 'white'};
  background: ${({ backgroundColor }: DivProps) => backgroundColor || 'black'};
  width: ${({ buttonWidth }: DivProps) => buttonWidth || 'fit-content'};
  font-size: ${({ fontSize }: DivProps) => fontSize || 'auto'};
  &:hover {
    cursor: pointer;
  }
`

export const StyledImageButton = styled.a`
  width: fit-content;
`

export const ImageButton = styled.img`
  width: 100%;
  max-width: ${({ buttonWidth }: DivProps) => buttonWidth || 'fit-content'};
  transition: all .25s;
  &:hover {
    cursor: pointer;
    opacity: 0.7;
  }
`

export const ProductContainer = styled.div`
  position: relative;
  overflow: hidden;
  font-family: Avenir;
  &:hover {
    .hoverImage { display: block; }
    .infoProduct, .hoverControls { display: flex; }
  }
`

export const ImagePreview = styled.img`
  object-fit: cover;
  width: 100%;
  cursor: pointer;
`

export const ImageHover = styled.img`
  position: absolute;
  display: none;
  z-index: 2;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  animation: fade-in-hover 0.325s cubic-bezier(0, 0, 0.58, 1.0) both;
  @keyframes fade-in-hover {
    0% {
      opacity: 0;
      transform: scale(1);
    }
    75% {
      opacity: 1;
    }
    100% {
      opacity: 1;
      transform: scale(1.15);
    }
  }
`

export const Info = styled.div`
  position: absolute;
  padding: 12px 20px 10px 20px;
  background: linear-gradient(0deg, #ffffff17, #ffffff38, transparent);
  left: 0px;
  width: 100%;
  justify-content: space-between;
  bottom: 0;
  display: flex;
  z-index: 3;
  align-items: center;
  @media (max-width: 698px) {
    position: inherit;
    padding-top: 10px;
    z-index: 2;
    background: white;
    line-height: 1;
  }
`

export const LabelDiv = styled.div`
  display: flex;
  align-items: flex-start;
  flex-flow: column;
  line-height: 1.25;
  text-align: left;
`

export const CustomIcon = styled.img`
  width: 18px;
  margin-top: -4px;
  margin-right: 10px;
`

export const ProductName = styled.div`
  font-size: 12px;
  font-weight: bold;
  display: flex;
  align-items: center;
`

export const LearnMore = styled.div`
  border: 1px solid black;
  padding: 4px 10px;
  color: black;
  transition: background .25s;
  &:hover {
    cursor: pointer;
    background: white;
  }
  @media (max-width: 698px) {
    display: none;
  }
`

export const Hyperlink = styled(Icon)`
  display: none;
  @media (max-width: 698px) {
    display: block;
    transform: scaleX(-1);
    color: cornflowerblue;
    font-size: 18px;
    margin-right: -6px;
  }
`

export const ProductInfo = styled.div`
  position: absolute;
  display: none;
  bottom: 100px;
  justify-content: space-between;
  background: #00000066;
  width: 100%;
  padding: 8px 18px;
  color: white;
  text-align: left;
  z-index: 3;
  animation: fade-in-info 0.25s cubic-bezier(0, 0, 0.58, 1.0) both;
  @keyframes fade-in-info {
    0% {
      opacity: 0;
      transform: translateY(14px);
    }
    100% {
      opacity: 1;
      transform: translateY(0px);
    }
  }
`

export const SizeRangeLabel = styled.div`
  font-weight: 500;
  text-transform: uppercase;
  font-size: 10px;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/screens/Blog/styledComponents.tsx